import { render, staticRenderFns } from "./ContractMareList.vue?vue&type=template&id=01056fbe&"
import script from "./ContractMareList.vue?vue&type=script&lang=js&"
export * from "./ContractMareList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports